export default {
  talk_to_us: 'Vorbiți cu noi:',
  send_us_email: 'Trimiteți-ne un email:',
  visit_website: 'Vizitați site-ul nostru:',
  join_our_community: 'Alăturați-vă comunității pentru oferte exclusive și noutăți!',
};
